import { COMMON_GENERAL_CONFIG } from "@common-shared/config/general.config"

export enum BrowserStorageType {
    localStorage = "localStorage",
    sessionStorage = "sessionStorage",
}

export enum AvailableUserIdleState {
    active = "active",
    prompt = "prompt",
    idle = "idle",
}

export const FRONT_GENERAL_CONFIG = {
    ...COMMON_GENERAL_CONFIG,

    rootElementId: "root",

    defaultPageTitle: "Nirvana",

    isLocal: import.meta.env.VITE_ENV === "local",
    isStaging: import.meta.env.VITE_ENV === "stage",
    isSandbox: import.meta.env.VITE_ENV === "sandbox",
    isProduction: import.meta.env.VITE_ENV === "prod",

    defaultToastrTimeout: 8 * 1000, // in ms
    extendedToastrTimeout: 15 * 1000, // in ms
    extendedPlusToastrTimeout: 20 * 1000, // in ms

    supportEmail: "help@meetnirvana.com",
    supportPortalUrl: "https://meetnirvana.zendesk.com",

    sftp: {
        hostnameExample: "sftp.meetnirvana.com",
        port: 22,
    },

    mainWebsiteUrl: "https://www.meetnirvana.com",
    calculatorUrl: "https://calculator.meetnirvana.com",
    clientPortalUrl: "https://client.meetnirvana.com",
    supportedInsurersUrl:
        "https://calculator.meetnirvana.com/supported-insurers",

    defaultPaginationLength: 15,
    defaultExtendedPaginationLength: 20,

    urlSearchParamsKeys: {
        // General
        step: "step",
        redirectTo: "redirectTo",
        flashMessage: "flash",

        // Calculator
        embed: "embed",
        npi: "npi",
        sessionCharge: "sessionCharge",
        purchase: "purchase",
        nirvanaAdmin: "nirvanaAdmin",
        embedCheckoutTherapists: "t",
        checkoutSessionId: "checkoutSessionId",
        whiteLabeled: "whitelabeled",
        withPracticeCreation: "withPracticeCreation",
        logo: "logo",

        // OV
        inviteToken: "invitation",
        email: "email",
        verificationCode: "verificationCode",
        tab: "tab",
        checkerMode: "checkerMode",
        create: "create",
        results: "results",
        filters: "filters",
        ignoreListReload: "ignoreListReload",
        reloadPoliciesList: "reloadPoliciesList",
        isSmartScanResult: "isSmartScanResult",
        from: "from",
        dashboard: "dashboard",
        question: "question",
    },

    browserStorageKeys: {
        // General
        tokenKey: "token",
        promoClosedAt: "promoClosedAt",

        // Calculator
        embedKey: "embedKey",
        embedCheckoutConfiguredData: "embedCheckoutConfiguredData",

        // Labeling Platform
        selectedTaskAssignmentStatus: "selectedTaskAssignmentStatus",
        tasksSortConfigration: "tasksSortConfigration",
        tasksFiltersConfiguration: "tasksFiltersConfiguration",
        tasksColumnsConfiguration: "tasksColumnsConfiguration",
        tasksTabsConfiguration: "tasksTabsConfiguration",

        // OV
        adminViewAsKey: "admin-view-as",
        inviteToken: "invite-token",
        appVersion: "appVersion",
        appVersionIgnoreUntil: "appVersionIgnoreUntil",
        authForceResetMFA: "authNeedResetMFA",
        selectedPracticeId: "selectedPracticeId",
        policiesColumnsConfigurationSuffix: "_columnsConfiguration",
        policiesFiltersConfigurationSuffix: "_filtersConfiguration",
        policiesSortConfigurationSuffix: "_sortConfiguration",
        policiesVisualizationCollapsedSuffix: "_visualizationCollapsed",
        policiesResultsPerPageSuffix: "_resultsPerPage",
        needTrackLoggedInEvent: "needTrackLoggedInEvent",
        policySidebarViewMode: "policySidebarViewMode",
        coverageHistoryMode: "coverageHistoryMode",
        enabledFeatureFlags: "enabledFeatureFlags",
        networkStatusRulesFilters: "networkStatusRulesFilters",
        demoSession: "oneVerifyDemoSession",
    },

    // Keys that are going to be prepended with practiceId to scope them to a specific practice
    // OV only, for now. This is to avoid conflicts when user swtiches between practices and has different configurations for each practice
    get browserStorageKeysPracticeScoped(): string[] {
        return [
            FRONT_GENERAL_CONFIG.browserStorageKeys
                .policiesColumnsConfigurationSuffix,
            FRONT_GENERAL_CONFIG.browserStorageKeys
                .policiesFiltersConfigurationSuffix,
            FRONT_GENERAL_CONFIG.browserStorageKeys
                .policiesSortConfigurationSuffix,
            FRONT_GENERAL_CONFIG.browserStorageKeys.networkStatusRulesFilters,
        ]
    },

    headers: {
        // General
        authorization: "Authorization",
        contentType: "Content-Type",

        // Calculator
        embedKey: "nirvana-calculator-embed-key",
        managementKey: "nirvana-calculator-management-key",
    },
}
